import { useEffect, useMemo, useState } from 'react';
import { Form } from '@bedrock/components';
import { useDebounceFn } from 'ahooks';

export const useSForm = function <T = Record<string, any>>(props?: {
  initialValues?: T;
}) {
  const { initialValues } = props || {};
  const [formBase] = Form.useForm();
  // @ts-ignore
  const [formData, setFormData] = useState<T>(initialValues || {});

  useEffect(() => {
    if (initialValues) {
      formBase.setFieldsValue?.(initialValues);
    } else {
      setFormData(formBase.getFieldsValue());
    }
  }, []);

  // 更新formData，用于注入到表单中，用于表单内部联动
  const { run: updateFormData } = useDebounceFn(
    () => {
      setFormData({ ...formBase.getFieldsValue() });
    },
    {
      wait: 200,
      leading: false,
      trailing: true,
    }
  );

  const form: typeof formBase = useMemo(() => {
    return {
      ...formBase,
      validateFields: (...args) => {
        const proms = formBase.validateFields(...args);
        proms.catch((err) => {
          if (err.errorFields.length) {
            form.scrollToField(err.errorFields[0].name, {
              behavior: 'smooth',
            });
          }
        });
        return proms;
      },
      setFieldsValue: (values) => {
        formBase.setFieldsValue(values);
        updateFormData();
      },
      setFieldValue: (name, value) => {
        formBase.setFieldValue(name, value);
        updateFormData();
      },
      resetFields: () => {
        formBase.resetFields();
        updateFormData();
      },
    };
  }, [formBase]);

  return {
    form,
    formData,
    updateFormData: updateFormData,
  };
};
